export const routes = {
  login: "/",
  callback: "/callback",

  dashboard: {
    taskManager: "/dashboard/task-manager",
    tasks: "/dashboard/tasks",
  },

  administration: {
    brandSettings: "/administration/brand-settings",
    lists: "/administration/lists",
    permissions: "/administration/permissions",
    workflows: "/administration/workflows",
  },
  test: "/test",
} as const;

export const roles = {
  admin: "Administrator",
  user: "User",
  none: "None",
} as const;

export type Role = (typeof roles)[keyof typeof roles];
